import Header from "../components/Header";
import Banner from "../components/Banner";
import ErrorPage from "../components/ErrorPage";
import GlobalMenu from "../components/GlobalMenu";
import Footer from "../components/Footer";
import ErrorMarcos from "../../public/images/404_marcos.svg";
import ErrorLeni from "../../public/images/404_Leni.svg";
import ErrorIsko from "../../public/images/404_Isko.svg";
import ErrorPing from "../../public/images/404_Ping.svg";
import ErrorLeody from "../../public/images/404_Leody.svg";
import ErrorManny from "../../public/images/404_Manny.svg";
import styles from "../styles/homepage/Home.module.scss";

const Custom404 = () => {
  const randomImages = () => {
    var images = [],
      graphics = 0;
    images[0] = ErrorMarcos;
    images[1] = ErrorLeni;
    images[2] = ErrorIsko;
    images[3] = ErrorPing;
    images[4] = ErrorLeody;
    images[5] = ErrorManny;
    graphics = Math.floor(Math.random() * images.length);
    return images[graphics];
  };

  return (
    <div className={styles.container}>
      <Header />
      <Banner />
      <GlobalMenu />
      <ErrorPage
        graphics={randomImages()}
        errorMessage="We can't seem to find the page you're looking for."
      />
      <Footer />
    </div>
  );
};

export default Custom404;
